export const isValidDate = (date: Date) => {
    // @ts-ignore
    return date instanceof Date && !isNaN(date);
}
